import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LabelsService {
  
  _baseUrl: string;

  constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._baseUrl = baseUrl;
  }

  getLabelsForSupplier(view: number, filters?: LabelFilters, selectedEan?: number): Observable<ISupplierLabels> {
    const requestUrl = this._baseUrl + 'api/label/GetForSupplierAsync';
      console.log(filters);
      console.log(filters?.potmaat);
    let param = {};

    param['view'] = view;
    if (selectedEan) {
      param['forKwekerEan'] = selectedEan;
    }
    if (filters?.searchTerm) {
        param['searchTerm'] = filters.searchTerm;
      }
      if (filters?.potmaat) {
          param['potmaat'] = filters.potmaat;
      }
      if (filters?.leverdatum) {
          param['leverdatum'] = filters.leverdatum.toISOString();
      }
      if (filters?.levertijdstip) {
          param['levertijdstip'] = filters.levertijdstip;
      }
      if (filters?.kwekerartikelnr) {
          param['kwekerartikelnr'] = filters.kwekerartikelnr;
      }

    return this._httpClient.get<ISupplierLabels>(requestUrl, { params: param });
  }

  getLabelsForOrder(orderNr: string, selectedEan?: number): Observable<ILabelRow[]> {
    const requestUrl = this._baseUrl + 'api/label/GetLabelsForOrder';
    let param = {};
    param['orderNr'] = orderNr;
    if (selectedEan) {
      param['forKwekerEan'] = selectedEan;
    }
    return this._httpClient.get<ILabelRow[]>(requestUrl, { params: param });
  }


  downloadPDF(orderNrs: string[]) : Observable<Blob | MediaSource> {
    const requestUrl = this._baseUrl + 'api/label/openasync';
    const param = { 'orderNrs': orderNrs };

    return this._httpClient.get(requestUrl, { params: param, responseType: 'blob' });
  }

  markAsUnprinted(orderNrs: string[]) : Observable<any> {
    const requestUrl = this._baseUrl + 'api/label/markAsUnprinted';

    return this._httpClient.post(requestUrl,  orderNrs );
  }

  update(item: ILabelRow): Observable<any> {
    const requestUrl = this._baseUrl + 'api/label/' + item.id;

    return this._httpClient.put(requestUrl, item);
  }
}

export interface ISupplierLabels {
  items: ILabelRow[];
  totalCount: number;
}

export interface ILabelRow {
  id: number;
  labelId: number;
  orderNr: string;
  datumAangemaakt?: Date;
  labelIsCreated: boolean;
  ophaalMethode: string;
  ophaalDatum?: Date;
  potmaat?: number;
  barCode: string;
  leverDatumTijdstip?: Date;
  leverTijdstip: string;
  kwekerArtikelNr: string;
  debiteurNrs: string[];
  klantArtikelOmschrijving: string;
  stickerBelading: string;
}

export class LabelFilters {
    searchTerm?: string;
    get searchTermIsEmpty(): boolean {
        return this.searchTerm == null || this.searchTerm == undefined || this.searchTerm == '';
    }
    
    kwekerartikelnr?: string;
    potmaat?: string;
    leverdatum?: Date;
    levertijdstip?: Date;
}